function GetVideoData() {
    return require('./videos_data.json'); 
}

function GetGenreData(){
    return require('./games_data.json')
}

export {GetVideoData, GetGenreData}